import { useState } from "react";

export default function InstallButton() {
  const [hovered, setHovered] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("cc-install-dismissed") === "1"
  );

  if (dismissed) return null;

  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem("cc-install-dismissed", "1");
    setDismissed(true);
  };

  return (
    <a
      href="https://chromewebstore.google.com/detail/gbffbncfnnodmgcpkdmpnclghfcnmojm"
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed",
        left: "24px",
        bottom: "24px",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "#18181b",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: "100px",
        padding: "10px 16px 10px 10px",
        textDecoration: "none",
        boxShadow: "0 4px 24px rgba(0,0,0,0.25)",
        animation: "slideUp 0.4s cubic-bezier(0.34,1.4,0.64,1) both",
        transition: "transform 0.15s",
        transform: hovered ? "scale(1.05)" : "scale(1)",
      }}
    >
      {/* Pulse dot */}
      <span style={{ position: "relative", width: 10, height: 10, flexShrink: 0 }}>
        <span style={{
          display: "block", width: 10, height: 10,
          borderRadius: "50%", background: "#22c55e",
        }} />
        <span style={{
          position: "absolute", inset: -3,
          borderRadius: "50%", border: "2px solid #22c55e",
          animation: "ping 1.6s ease-out infinite",
        }} />
      </span>

      {/* Chrome logo */}
      <svg width="18" height="18" viewBox="0 0 48 48">
        <path fill="#EA4335" d="M24 14h18.4A20 20 0 0 0 5.6 14z"/>
        <path fill="#4285F4" d="M42.4 14A20 20 0 0 1 22.3 43.9L31 28.5A10 10 0 0 0 34 24z"/>
        <path fill="#34A853" d="M5.6 14A20 20 0 0 0 25.7 43.9L17 28.5A10 10 0 0 1 14 24z"/>
        <circle cx="24" cy="24" r="7" fill="white"/>
        <circle cx="24" cy="24" r="5" fill="#4285F4"/>
      </svg>

      {/* Text */}
      <span style={{ fontSize: 13, fontWeight: 600, color: "#fff", whiteSpace: "nowrap" }}>
        Add to Chrome
      </span>

      {/* Dismiss button — only visible on hover */}
      {hovered && (
        <span
          onClick={handleDismiss}
          title="Dismiss"
          style={{
            marginLeft: 4,
            width: 18, height: 18,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.12)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 11, color: "#aaa",
            cursor: "pointer",
            flexShrink: 0,
            transition: "background 0.15s",
          }}
        >
          ✕
        </span>
      )}

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes ping {
          0%   { transform: scale(0.8); opacity: 0.8; }
          100% { transform: scale(2.2); opacity: 0; }
        }
      `}</style>
    </a>
  );
}